export default __webpack_public_path__ + "static/Structure3DLoads-84061a33565c35a8c0555fd43cc0cbdd.jpg";